export default __webpack_public_path__ + "static/rightimg-4edf1d4a320e641b403970024577733a.png";